import { defineMessages } from '@jutro/locale';

export default defineMessages({
    close: {
        id: 'adac.labels.components.AdacDocumentSigningPage.Close',
        defaultMessage: 'Close'
    },
    submittedSuccessfully: {
        id: 'adac.labels.components.AdacDocumentSigningPage.Submitted successfully',
        defaultMessage: 'Submitted successfully'
    },
    submissionFailed: {
        id: 'adac.labels.components.AdacDocumentSigningPage.Submission failed',
        defaultMessage: 'Failed to sign the document. \nPlease try again later or contact our ADAC Ambulanze-Service using the below phone number: +49 89 767676.'
    }
});
